export const viewerText = {
  en: {
    places: "Jump to a place",
    map: "Field map",
    language: "Language",
    checking: "Checking for the latest map…",
    version: "Version",
    updated: "Updated",
    offline:
      "OFFLINE — Current changes cannot be checked. Reconnect to get the latest map.",
    unavailable: "This map is not currently available.",
    sample: "FICTIONAL EXAMPLE — Not a real site plan",
    guidance:
      "General orientation. No navigation or surveyed boundaries. Review while stopped.",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    returnView: "Return to map view",
    locationOff: "Turn my location off",
    locationOn: "Show my location",
    locationApproximate: "Your device location — approximate",
    locationUnavailable: "Location is unavailable on this device.",
    locationPermission: "Location could not be found. Check device permission.",
    orientation: "Orientation only · No surveyed boundaries",
    locationLocal: "Location stays on this device",
    noBasemap:
      "Basemap not configured. Showing markings on a plain background.",
    mapError: "Some map imagery could not load. Check your connection.",
    photo: "Map photo",
  },
  es: {
    places: "Ir a un lugar",
    map: "Mapa de campo",
    language: "Idioma",
    checking: "Buscando la versión más reciente…",
    version: "Versión",
    updated: "Actualizado",
    offline:
      "SIN CONEXIÓN — No se pueden verificar los cambios. Conéctese para ver el mapa más reciente.",
    unavailable: "Este mapa no está disponible en este momento.",
    sample: "EJEMPLO FICTICIO — No es un plano real",
    guidance:
      "Orientación general. No es navegación ni un límite topográfico. Revise el mapa cuando esté detenido.",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    returnView: "Volver a la vista del mapa",
    locationOff: "Ocultar mi ubicación",
    locationOn: "Mostrar mi ubicación",
    locationApproximate: "Ubicación aproximada de su dispositivo",
    locationUnavailable: "La ubicación no está disponible en este dispositivo.",
    locationPermission:
      "No se pudo obtener la ubicación. Revise los permisos del dispositivo.",
    orientation: "Solo orientación · Sin límites topográficos",
    locationLocal: "Su ubicación permanece en este dispositivo",
    noBasemap:
      "Mapa base no configurado. Se muestran las marcas sobre un fondo liso.",
    mapError: "No se pudieron cargar algunas imágenes. Revise su conexión.",
    photo: "Foto del mapa",
  },
  fr: {
    places: "Aller à un lieu",
    map: "Carte de terrain",
    language: "Langue",
    checking: "Recherche de la dernière version…",
    version: "Version",
    updated: "Mis à jour",
    offline:
      "HORS LIGNE — Les changements ne peuvent pas être vérifiés. Reconnectez-vous pour consulter la dernière carte.",
    unavailable: "Cette carte est actuellement indisponible.",
    sample: "EXEMPLE FICTIF — Ce n’est pas un plan réel",
    guidance:
      "Orientation générale. Ni navigation ni limites arpentées. Consultez la carte à l’arrêt.",
    zoomIn: "Agrandir",
    zoomOut: "Réduire",
    returnView: "Revenir à la vue de la carte",
    locationOff: "Masquer ma position",
    locationOn: "Afficher ma position",
    locationApproximate: "Position approximative de votre appareil",
    locationUnavailable: "La position n’est pas disponible sur cet appareil.",
    locationPermission:
      "Position introuvable. Vérifiez les autorisations de l’appareil.",
    orientation: "Orientation seulement · Aucune limite arpentée",
    locationLocal: "Votre position reste sur cet appareil",
    noBasemap: "Fond de carte non configuré. Repères affichés sur un fond uni.",
    mapError:
      "Certaines images n’ont pas pu être chargées. Vérifiez votre connexion.",
    photo: "Photo de la carte",
  },
} as const;
